import { isMobile } from "react-device-detect";
import { Box, Button, Divider, IconButton, InputAdornment, OutlinedInput, Stack, Tooltip, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import DepartmentTable from "./table";
import { Outlet, useNavigate } from "react-router";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import CachedIcon from "@mui/icons-material/Cached";
import { useTheme } from "@mui/material/styles";
import Loader from "../../common/loader";
import { toast } from "react-toastify";
import { isLogin } from "../../../services/authService";

const { getDepartments } = require("../../../services/departmentService");

export default function Departments() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [reload, setReload] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [filteredDepartments, setFilteredDepartments] = useState([]);

    useEffect(() => {
        document.title = "Techlogics | Departments";
        if (!isLogin()) navigate("/admin-login");

        getDepartments()
            .then((res) => {
                setDepartments(res.data.data);
                setFilteredDepartments(res.data.data);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    }, [reload]);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        if (e.target.value === "") {
            setFilteredDepartments(departments);
        } else {
            const filtered = departments.filter((department) => {
                return department.code.toLowerCase().includes(e.target.value.toLowerCase());
            });
            setFilteredDepartments(filtered);
        }
    };

    const handleClearSearch = () => {
        setSearch("");
        setFilteredDepartments(departments);
    };

    const handleRefresh = () => {
        setSearch("");
        setIsLoading(true);
        setReload(!reload);
        toast.success("Departments Refreshed");
    };

    return (
        <Box p={2} gap={2} sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" } }}>
            <Box width={{ xs: "100%", sm: "90%" }}>
                <Stack direction={"row"} gap={1} alignItems={"center"}>
                    <Typography className='purple' variant='h6'>
                        Department List
                    </Typography>
                    <Tooltip title='Refresh' placement='right'>
                        <IconButton color='' size='small' onClick={handleRefresh}>
                            <CachedIcon />
                        </IconButton>
                    </Tooltip>
                </Stack>
                <Box py={1} sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1, alignItems: "center" }}>
                    <OutlinedInput
                        fullWidth
                        type='text'
                        placeholder='Search Department'
                        sx={{
                            flex: 1,
                        }}
                        size='small'
                        value={search}
                        onChange={handleSearch}
                        endAdornment={
                            <Tooltip title='Clear'>
                                <IconButton onClick={handleClearSearch}>
                                    <FilterAltOffIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        startAdornment={
                            <InputAdornment position='start'>
                                <SearchIcon color='primary' sx={{ marginRight: 1 }} />
                            </InputAdornment>
                        }
                    />
                    <Button
                        // fullWidth={{ xs: true, md: false }}
                        size={isMobile ? "small" : "medium"}
                        variant='contained'
                        color=''
                        sx={{ color: "#30369e" }}
                        onClick={() => navigate("/admin/departments/tab=1/add")}
                    >
                        Add Department
                    </Button>
                </Box>
                {isLoading && <Loader message={"Fetching departments"} />}
                {!isLoading && <DepartmentTable filteredDepartments={filteredDepartments} />}
            </Box>
            <Divider orientation={isMobile ? "horizontal" : "vertical"} flexItem />
            <Box width={"100%"} sx={{ xs: 0, sm: 1 }}>
                <Outlet />
            </Box>
        </Box>
    );
}
